import { TabRouteType } from '@dfl/react-security';
import PortraitOutlinedIcon from '@mui/icons-material/PortraitOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { renderTabLabel } from 'modules/common/components/TabsWithSections/TabLabel/TabLabel';
import { TERMS_PERMISSIONS } from './terms.permissions';

const path = '/cms/terms';

export const termsTabs: TabRouteType[] = [
  {
    path: `${path}/general`,
    to: '/general',
    label: 'tabs.general',
    translate: true,
    render: () =>
      renderTabLabel({ locale: 'terms', label: 'tabs.general', Icon: PortraitOutlinedIcon }),
    permissions: [TERMS_PERMISSIONS.TERMS_VIEW],
  },
  {
    path: `${path}/history`,
    to: '/history',
    label: 'tabs.history',
    translate: true,
    render: () =>
      renderTabLabel({ locale: 'terms', label: 'tabs.history', Icon: HistoryOutlinedIcon }),
    permissions: [TERMS_PERMISSIONS.TERMS_VIEW],
  },
];
